var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDioxin01(_ref, svgRef) {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 955.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "321.06 729.16 253.15 705.74 253.15 729.16 185.25 705.74 185.25 729.16 117.35 705.74 117.35 760.75 117.35 803.06 117.56 860.46 165.12 860.46 164.93 951.68 320.96 951.68 320.96 860.46 321.05 860.46 321.05 803.06 321.06 803.06 321.06 729.16",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_42",
    "data-name": "Ebene 42"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.8,
    cy: 236.14,
    r: 32.54,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.1,
    cy: 214.23,
    r: 65.9,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.97,
    cy: 214.23,
    r: 48.69,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.17,
    cy: 247.99,
    r: 39.61,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.57,
    cy: 219.94,
    r: 57.43,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.89,
    cy: 219.94,
    r: 35.84,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.78,
    cy: 298.96,
    r: 16.12,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.81,
    cy: 294.02,
    r: 22.82,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.51,
    cy: 287.68,
    r: 29.52,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.73,
    cy: 263.64,
    r: 19.35,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 280.65,
    r: 40.12,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.78,
    cy: 275.72,
    r: 47.24,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.79,
    cy: 292.62,
    r: 35.61,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.77,
    cy: 416.3,
    r: 12.46,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.2,
    cy: 363.86,
    r: 4.49,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.56,
    cy: 396.45,
    r: 19.86,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.1,
    cy: 371.49,
    r: 22.67,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.54,
    cy: 340.61,
    r: 20.21,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.03,
    cy: 367.98,
    r: 18.43,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.93,
    cy: 347.49,
    r: 13.36,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.21,
    cy: 466.03,
    r: 7.66,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.61,
    cy: 455.72,
    r: 7.66,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.32,
    cy: 411.52,
    r: 11.42,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.07,
    cy: 445.97,
    r: 9.75,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.89,
    cy: 423.87,
    r: 9.75,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.3,
    cy: 431.5,
    r: 12.06,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.15,
    cy: 415.54,
    r: 13.77,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.61,
    cy: 391.48,
    r: 20.22,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.29,
    cy: 394.15,
    r: 13.98,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.53,
    cy: 438.7,
    r: 13.84,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.37,
    cy: 294.02,
    r: 13.36,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.72,
    cy: 298.96,
    r: 13.36,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.69,
    cy: 331.94,
    r: 20.21,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.5,
    cy: 375.56,
    r: 15.56,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.04,
    cy: 345.92,
    r: 26.43,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.39,
    cy: 309.51,
    r: 20.21,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.71,
    cy: 319.17,
    r: 20.21,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.78,
    cy: 316.57,
    r: 28.89,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.48,
    cy: 311.73,
    r: 28.89,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.77,
    cy: 381.17,
    r: 4.49,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.98,
    cy: 366.47,
    r: 8.18,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.18,
    cy: 319.17,
    r: 23.41,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.42,
    cy: 296.06,
    r: 19.35,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.51,
    cy: 317.2,
    r: 17.29,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.58,
    cy: 299.91,
    r: 12.34,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.55,
    cy: 284.29,
    r: 12.34,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.26,
    cy: 247.18,
    r: 19.35,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.28,
    y: -17.17,
    width: 399.72,
    height: 231.41,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.48,
    cy: 233.8,
    r: 34.19,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.11,
    cy: 219.94,
    r: 34.19,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.12,
    cy: 222.53,
    r: 29.18,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.32,
    cy: 400.97,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.36,
    cy: 342.58,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.14,
    cy: 477.58,
    r: 3.58,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.02,
    cy: 295.76,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.9,
    cy: 309.51,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.9,
    cy: 276.29,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.99,
    cy: 215.7,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.02,
    cy: 206,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.06,
    cy: 258.11,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.82,
    cy: 231.16,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.15,
    cy: 276.29,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.66,
    cy: 162.51,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.4,
    cy: 238.44,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.55,
    cy: 102.93,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.78,
    cy: 262.22,
    r: 6.8,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.59,
    cy: 41.68,
    r: 29.18,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.18,
    cy: 39.35,
    r: 18.1,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.21,
    cy: 115.67,
    r: 22.81,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.04,
    cy: 62.76,
    r: 32.95,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.88,
    cy: 41.34,
    r: 33.2,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.04,
    cy: 87.61,
    r: 48.69,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.8,
    cy: 90.08,
    r: 33.2,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.1,
    cy: 59.36,
    r: 52.3,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.8,
    cy: 87.36,
    r: 41.61,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.38,
    cy: 31.17,
    r: 46.5,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.05,
    cy: 15.97,
    r: 18.73,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.04,
    cy: 89.08,
    r: 18.73,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.4,
    cy: 134.67,
    r: 14.12,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.27 658.38 222.96 658.38 141.74 658.38 141.74 760.75 267.27 760.75 267.27 658.38",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.06 729.16 253.15 705.74 253.15 729.16 185.25 705.74 185.25 729.16 117.35 705.74 117.35 760.75 117.35 803.06 117.35 860.46 164.93 860.46 164.93 951.68 320.96 951.68 320.96 860.46 321.05 860.46 321.05 803.06 321.06 803.06 321.06 729.16",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.69,850.22a3.68,3.68,0,0,1-.75-4.74c.43-.85,3.43-.46,6.51-1.91s1.83-3.4,2-6.24-1.58-6.27-1.58-6.27l.92-.11c-1.47-.32-1.26-.4-1.77-.81l-.09-.14a.49.49,0,0,1-.34-.08c-.31-.18.07-.12-1.71-.52s-4-.24-5,.5-1.83,3.05-2.11,3.58-3.05,3.22-3.27,3.73-2,3.89-2.21,4.06-2.37,3.86-2.37,3.86-.13,0,.13.67.57.94,1.42,1.28,4,3.1,5.12,3.64,2.9,1,4,1.89a50,50,0,0,0,5,3.49A25,25,0,0,0,190.69,850.22Z",
    style: {
      fill: "#dedfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8,831l.28.11Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: "0.30000000000000004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,848.67c.43-.58,1-2.6,1.66-3.82a6.86,6.86,0,0,0,.28-4.55,14,14,0,0,1-.45-2.75,11.1,11.1,0,0,0-1.45-3.26c-.32-.45-1.36-1-2.11-2a4.67,4.67,0,0,0-1.68-1.24l-.28-.11-.92.11s1.76,3.44,1.58,6.27,1.08,4.79-2,6.24-6.08,1.06-6.51,1.91a3.68,3.68,0,0,0,.75,4.74,25,25,0,0,1,3.93,5.88l.12.06a23.49,23.49,0,0,0,4,1.16c1.2.32-.44-2.13.21-2.23S201.39,849.26,201.83,848.67Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.08,830.87a4.53,4.53,0,0,0-3.19.88c-1.3,1.11-2.28,1.52-2.3,2.12s1.19-.56,1.73-1S195.19,830.84,196.08,830.87Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.39,832.32c.15-.08-2.64,2-3.24,2.67s-.74,1.06-.55,1.21,1.33-.74,1.93-1.5A23.36,23.36,0,0,1,195.39,832.32Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.23,833.18a33.12,33.12,0,0,0-1.41,3.73c-.18.89-.25,2.13,0,2.11s.95-1.33,1.09-1.93.18-2,.31-2.47A5.91,5.91,0,0,0,196.23,833.18Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,829.67a5.15,5.15,0,0,0-1-2.68c-.57-1-1.19-.15-1.67-.62s-.92-1.63-1.57-1.27-.73,1.15-1.09,1.56-.8-.74-.86-.6a4.69,4.69,0,0,1-.28-1.6,3.67,3.67,0,0,0-2.22-1.46l-.52-.08a1.9,1.9,0,0,0-.58.05,2.41,2.41,0,0,0,1.06,1.52c1,.62,1.39.49,1.74,1.56L197,825.4s-.83.58.25,1.19c.89.51.75,1.29.59,2a1.37,1.37,0,0,1,.47,1.86c.06-.15,1.78.88,2.53,1a2.21,2.21,0,0,0,1.59-.25,8.47,8.47,0,0,1,2.43-.18C205.59,831.13,205.3,830.88,205.23,829.67Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2,826.59c-1.08-.61-.25-1.19-.25-1.19l1.27.65c-.35-1.07-.75-.94-1.74-1.56a2.41,2.41,0,0,1-1.06-1.52h-.07c-.34.1-.5.43-.76.62s-.05.72.12,1.4a7.52,7.52,0,0,0,.93,2.11c.3.39.82.8.77,1a2.43,2.43,0,0,1,1.38.53C198,827.88,198.09,827.1,197.2,826.59Z",
    style: {
      fill: "#dedfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8,831a2.63,2.63,0,0,0,.46-.45c.74-1.28-.78-2.35-1.85-2.39,0,.19-.46.35-.48.69a3.41,3.41,0,0,0,.12.89c0,.18,0,.28-.11.31l.09.14C196.54,830.55,196.33,830.63,197.8,831Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.64,919.78a3.68,3.68,0,0,1-.76-4.74c.43-.85,3.43-.46,6.52-1.91s1.82-3.4,2-6.24-1.59-6.28-1.59-6.28l.92-.11c-1.47-.31-1.26-.39-1.77-.8l-.09-.14a.46.46,0,0,1-.33-.08c-.31-.18.06-.12-1.72-.53s-4-.23-5,.51-1.84,3-2.12,3.58-3,3.22-3.27,3.73-2,3.89-2.21,4.06-2.37,3.86-2.37,3.86-.12,0,.14.67.56.94,1.41,1.28,4,3.1,5.12,3.64,2.9,1,4,1.89a47.09,47.09,0,0,0,5,3.48A25.09,25.09,0,0,0,260.64,919.78Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,900.5l.29.12Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.77,918.23c.44-.59,1-2.6,1.67-3.82a7,7,0,0,0,.28-4.55,13.29,13.29,0,0,1-.45-2.75,11.1,11.1,0,0,0-1.46-3.26c-.32-.45-1.36-1-2.11-2a4.65,4.65,0,0,0-1.67-1.24l-.29-.12-.92.11s1.77,3.45,1.59,6.28,1.07,4.79-2,6.24-6.09,1.06-6.52,1.91a3.68,3.68,0,0,0,.76,4.74,25.09,25.09,0,0,1,3.92,5.87l.12.07a23.77,23.77,0,0,0,4,1.16c1.2.32-.44-2.13.21-2.23S271.33,918.82,271.77,918.23Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,900.43a4.54,4.54,0,0,0-3.19.88c-1.3,1.11-2.28,1.52-2.29,2.12s1.18-.56,1.72-1S265.13,900.4,266,900.43Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34,901.88c.15-.08-2.65,2-3.25,2.67s-.73,1.06-.54,1.21,1.32-.74,1.92-1.5A22.08,22.08,0,0,1,265.34,901.88Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.17,902.74a33.12,33.12,0,0,0-1.41,3.73c-.17.89-.25,2.13,0,2.11s.95-1.33,1.1-1.93.18-2,.3-2.47A5.91,5.91,0,0,0,266.17,902.74Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.18,899.23a5.29,5.29,0,0,0-1-2.68c-.58-1-1.2-.15-1.68-.62s-.92-1.64-1.56-1.27-.74,1.15-1.09,1.56-.8-.75-.87-.6a5,5,0,0,1-.28-1.61,3.71,3.71,0,0,0-2.22-1.45l-.52-.08a1.84,1.84,0,0,0-.57,0,2.33,2.33,0,0,0,1.06,1.52c1,.62,1.39.49,1.74,1.56l-1.28-.65s-.82.58.25,1.19c.9.51.75,1.29.6,2.05a1.38,1.38,0,0,1,.46,1.86c.07-.15,1.78.88,2.53,1a2.15,2.15,0,0,0,1.59-.24,8.47,8.47,0,0,1,2.43-.18C275.53,900.69,275.25,900.43,275.18,899.23Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.14,896.15c-1.07-.61-.25-1.19-.25-1.19l1.28.65c-.35-1.07-.76-.94-1.74-1.56a2.33,2.33,0,0,1-1.06-1.52h-.08c-.34.1-.49.43-.75.62s-.06.71.11,1.4a7.25,7.25,0,0,0,.94,2.11c.3.39.81.8.77,1a2.48,2.48,0,0,1,1.38.53C267.89,897.44,268,896.66,267.14,896.15Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,900.5a2.21,2.21,0,0,0,.46-.44c.75-1.28-.77-2.35-1.84-2.39-.05.19-.47.35-.49.69a3,3,0,0,0,.13.89c0,.18,0,.28-.12.31l.09.14C266.48,900.11,266.27,900.19,267.74,900.5Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,874.4a3.65,3.65,0,0,1,4.71.85c.67.69-.69,3.39-.35,6.78s2.61,2.86,5.22,4,6.45.59,6.45.59l-.2.9c.78-1.28.79-1.06,1.35-1.4l.16,0a.43.43,0,0,1,.19-.29c.27-.23.09.1,1.06-1.44s1.55-3.71,1.18-4.88-2.28-2.75-2.68-3.19-2-3.93-2.44-4.32-3-3.17-3.1-3.42-2.85-3.52-2.85-3.52,0-.11-.68-.09a2,2,0,0,0-1.68.91c-.6.69-4.25,2.76-5.13,3.62a21.11,21.11,0,0,1-3.11,3.18,48.6,48.6,0,0,0-5,3.55A25.06,25.06,0,0,0,227.64,874.4Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.47,887.48l-.2.23Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.41,885.42c.41.6,2.13,1.79,3.05,2.83a6.84,6.84,0,0,0,4.21,1.77,13.87,13.87,0,0,1,2.74.49,11.24,11.24,0,0,0,3.56-.29c.53-.16,1.43-.94,2.57-1.34a4.7,4.7,0,0,0,1.73-1.17l.2-.23.2-.9s-3.83.52-6.45-.59-4.87-.57-5.22-4,1-6.09.35-6.78a3.65,3.65,0,0,0-4.71-.85,25.06,25.06,0,0,1-6.85,1.75l-.1.1a24.81,24.81,0,0,0-2.41,3.35c-.7,1,2.16.29,2,.94S225,884.81,225.41,885.42Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.11,885.88a4.53,4.53,0,0,0,.23-3.29c-.62-1.6-.68-2.66-1.24-2.87s.14,1.3.36,1.95S244.43,885.06,244.11,885.88Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,884.76c0,.17-1-3.15-1.44-4s-.77-1-1-.91.26,1.49.78,2.31A23.06,23.06,0,0,1,243,884.76Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.88,885.26a34.19,34.19,0,0,0-3-2.57c-.78-.45-1.93-.93-2-.71s.94,1.34,1.46,1.67,1.81.83,2.23,1.1A5.91,5.91,0,0,0,241.88,885.26Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.21,894.92a5.2,5.2,0,0,0,2.87-.08c1.17-.2.53-1.07,1.14-1.37s1.85-.33,1.71-1.06-.84-1.07-1.11-1.54,1-.51.86-.62a4.62,4.62,0,0,1,1.6.27,3.73,3.73,0,0,0,2.12-1.62l.24-.46a2.09,2.09,0,0,0,.14-.56,2.37,2.37,0,0,0-1.78.5c-.91.73-.93,1.15-2.05,1.12l1-1s-.28-1-1.21-.16c-.78.67-1.46.28-2.13-.12a1.36,1.36,0,0,1-1.91-.18c.12.11-1.42,1.39-1.83,2.05a2.19,2.19,0,0,0-.29,1.58A8.3,8.3,0,0,1,241,894C240.72,894.78,241.05,894.59,242.21,894.92Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.78,888.36c.93-.82,1.21.16,1.21.16l-1,1c1.12,0,1.14-.39,2.05-1.12a2.37,2.37,0,0,1,1.78-.5s0,0,0-.07c0-.36-.25-.61-.34-.92s-.65-.29-1.36-.36a7.4,7.4,0,0,0-2.29.19c-.48.15-1,.5-1.2.4a2.62,2.62,0,0,1-1,1.12C246.32,888.64,247,889,247.78,888.36Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.47,887.48a2,2,0,0,0,.27.58c1,1.13,2.47.05,2.87-.94-.17-.11-.19-.56-.5-.69a3.21,3.21,0,0,0-.87-.18c-.19,0-.27-.1-.26-.21l-.16,0C244.26,886.42,244.25,886.2,243.47,887.48Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,800.17a3.67,3.67,0,0,1,3.94-2.73c1,0,1.9,2.9,4.54,5s3.86.18,6.49-.88,5-4.13,5-4.13l.5.78c-.36-1.46-.2-1.31,0-2l.09-.14a.44.44,0,0,1-.08-.34c0-.35.14,0-.26-1.77s-1.52-3.72-2.61-4.29-3.55-.33-4.15-.36-4.22-1.35-4.77-1.34-4.37-.13-4.62-.24-4.5-.48-4.5-.48,0-.11-.55.42a2,2,0,0,0-.54,1.83c.06.91-1.07,4.95-1.08,6.18s.36,3.05,0,4.45a47,47,0,0,0-1,6A25.28,25.28,0,0,0,162,800.17Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.43,798.26v.31C182.44,798.38,182.43,798.26,182.43,798.26Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,809.54c.72.14,2.78-.23,4.17-.14a7,7,0,0,0,4.23-1.72,14.34,14.34,0,0,1,2.28-1.59,11,11,0,0,0,2.32-2.72c.26-.48.35-1.67.88-2.76a4.45,4.45,0,0,0,.39-2v-.31l-.5-.78s-2.35,3.07-5,4.13-3.86,3-6.49.88-3.59-5-4.54-5a3.67,3.67,0,0,0-3.94,2.73,25.28,25.28,0,0,1-3.61,6.07.66.66,0,0,0,0,.14,24,24,0,0,0,.66,4.07c.23,1.23,1.73-1.32,2.1-.77S167.45,809.4,168.17,809.54Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.75,796.67a4.55,4.55,0,0,0-2.16-2.49c-1.57-.69-2.36-1.41-2.91-1.16s1,.83,1.63,1.13S181.4,795.86,181.75,796.67Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.15,796.68c.14.1-2.92-1.53-3.81-1.78s-1.28-.2-1.33,0,1.24.88,2.19,1.09A24.21,24.21,0,0,1,180.15,796.68Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73,797.81a35.15,35.15,0,0,0-4,.33c-.88.23-2,.7-1.91.9a4.47,4.47,0,0,0,2.21.15c.61-.13,1.87-.69,2.36-.79A5.65,5.65,0,0,0,179.73,797.81Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.79,804.42a5.33,5.33,0,0,0,2-2.08c.69-1-.38-1.14-.16-1.78s1.08-1.54.47-2-1.36-.16-1.88-.31.33-1,.17-1a5,5,0,0,1,1.33-1,3.74,3.74,0,0,0,.35-2.63l-.15-.5a2.1,2.1,0,0,0-.29-.5,2.4,2.4,0,0,0-.92,1.62c-.13,1.15.16,1.46-.66,2.24l0-1.43s-.89-.5-1,.74c-.07,1-.83,1.23-1.59,1.42a1.36,1.36,0,0,1-1.47,1.22c.16,0,0,2,.15,2.74a2.2,2.2,0,0,0,.9,1.33,8.24,8.24,0,0,1,1.21,2.11C185.63,805.37,185.73,805,186.79,804.42Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.09,795.84c.09-1.24,1-.74,1-.74l0,1.43c.82-.78.53-1.09.66-2.24a2.4,2.4,0,0,1,.92-1.62l0-.06c-.23-.26-.6-.26-.88-.41s-.67.25-1.22.7a7.67,7.67,0,0,0-1.49,1.76c-.23.44-.37,1.08-.57,1.12a2.54,2.54,0,0,1,.11,1.48C185.26,797.07,186,796.87,186.09,795.84Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.43,798.26a2.41,2.41,0,0,0,.6.22c1.47.12,1.78-1.71,1.36-2.7-.2.05-.52-.26-.84-.13a3,3,0,0,0-.74.49c-.15.12-.26.11-.33,0l-.09.14C182.23,797,182.07,796.8,182.43,798.26Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.61,811.9a3.65,3.65,0,0,1,4.4,1.9c.49.81-1.44,3.14-1.87,6.52s1.89,3.37,4.19,5,6.15,2,6.15,2l-.4.84c1-1.08,1-.86,1.63-1.07h.17q0-.13.24-.24a5.58,5.58,0,0,0,2.06-1.51c1.29-1.28,2-2.64,2-3.87s.07-1.62-.23-2.13-3.16-6.15-3.47-6.61-2.21-3.78-2.24-4,1.19-3.6,1.19-3.6.08-.1-.64-.24-4.28-.5-5,0-4.76,1.73-5.81,2.37-2.4,1.92-3.76,2.39a50.11,50.11,0,0,0-5.61,2.35A25.23,25.23,0,0,0,160.61,811.9Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08,828.22l-.25.18Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,818.23a14.25,14.25,0,0,0,2.84-.6,47.82,47.82,0,0,1,3.64,4.5c.26.68,1.67,2.23,2.34,3.45s.74,1.7,2,2.07a39.11,39.11,0,0,1,4.27,1.7,11.09,11.09,0,0,0,3.53.52c.56,0,1.61-.59,2.82-.72a4.63,4.63,0,0,0,1.94-.75l.25-.18.4-.84s-3.85-.35-6.15-2-4.62-1.66-4.19-5,2.36-5.71,1.87-6.52a3.65,3.65,0,0,0-4.4-1.9,25.23,25.23,0,0,1-7.06.16l-.12.07a22.71,22.71,0,0,0-3.1,2.72,10.35,10.35,0,0,0-2.13,2.4C147.94,817.86,148.07,818.34,149.47,818.23Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.78,826.33s1.84-1.69,2.05-3.16.74-2.49.25-2.65-.56,1.23-.69,1.84S175.58,825.52,174.78,826.33Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.18,825.35a31.58,31.58,0,0,0,.63-3.66c-.05-.72-.24-.93-.53-.79a3.21,3.21,0,0,0-.43,2.15A11.09,11.09,0,0,1,174.18,825.35Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.75,825.92a12.54,12.54,0,0,0-1.85-2.21c-.58-.38-1.54-.75-1.72-.53s.27,1.21.64,1.48,1.47.65,1.77.88A3.8,3.8,0,0,0,172.75,825.92Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.42,835.93a5.22,5.22,0,0,0,2.81.57c1.19.07,2.35.54,3,.39s1.87.09,1.9-.65-.58-1.23-.73-1.75a19.25,19.25,0,0,0-.62-1.87,4.6,4.6,0,0,1,1.51.62,3.72,3.72,0,0,0,2.42-1.1l.34-.39a2.49,2.49,0,0,0,.27-.51,2.35,2.35,0,0,0-1.86.08c-1,.5-1.16.91-2.25.63l1.24-.72s-.05-1-1.15-.44c-.9.48-1.73-.8-2.29-1.34a1.37,1.37,0,0,1-1.82-.6c.09.13-1.7,1-2.24,1.58a2.17,2.17,0,0,0-.64,1.47,8.56,8.56,0,0,1-1.16,2.14C168.75,834.7,169.37,835.34,170.42,835.93Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.32,830.79c1.1-.58,1.15.44,1.15.44l-1.24.72c1.09.28,1.2-.13,2.25-.63a2.35,2.35,0,0,1,1.86-.08s0,0,0-.07c.11-.34-.09-.65-.11-1s-.57-.44-1.25-.66-2-1.13-2.53-1.09-1.11.27-1.25.12a2.56,2.56,0,0,1-1.19.88C175.59,830,176.42,831.27,177.32,830.79Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08,828.22a2.18,2.18,0,0,0,.13.63c.68,1.31,2.4.6,3-.28-.14-.14-.05-.58-.33-.78a2.84,2.84,0,0,0-.81-.37c-.18-.07-.24-.16-.2-.26h-.17C174.09,827.36,174.13,827.14,173.08,828.22Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,878.89a3.65,3.65,0,0,1-4.5-1.62c-.55-.79,1.24-3.23,1.46-6.63s-2.1-3.24-4.49-4.77-6.26-1.64-6.26-1.64l.34-.86c-1,1.14-1,.92-1.56,1.16h-.16a.46.46,0,0,1-.23.26,5.34,5.34,0,0,0-2,1.62c-1.21,1.36-1.89,2.77-1.72,4s0,1.62.35,2.12,3.54,5.94,3.87,6.38,2.44,3.63,2.49,3.89-1,3.67-1,3.67-.07.1.66.2,4.3.24,5-.35,4.65-2,5.65-2.72,2.28-2.06,3.6-2.61a50.33,50.33,0,0,0,5.46-2.69A25.3,25.3,0,0,0,223.78,878.89Z",
    style: {
      fill: "#dedfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.33,863.37l.24-.19Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: "0.30000000000000004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.52,871.89a14,14,0,0,0-2.8.77,49.12,49.12,0,0,1-3.91-4.26c-.31-.67-1.81-2.13-2.55-3.31s-.84-1.65-2.11-1.94a38.53,38.53,0,0,1-4.36-1.43,10.86,10.86,0,0,0-3.56-.3c-.55.06-1.57.69-2.76.89a4.55,4.55,0,0,0-1.9.87l-.24.19-.34.86s3.87.12,6.26,1.64,4.71,1.37,4.49,4.77-2,5.84-1.46,6.63a3.65,3.65,0,0,0,4.5,1.62,25.3,25.3,0,0,1,7-.59l.12-.08a24.39,24.39,0,0,0,2.93-2.91,10.21,10.21,0,0,0,2-2.53C236.07,872.16,235.91,871.69,234.52,871.89Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.75,865.36s-1.73,1.8-1.85,3.29-.58,2.52-.09,2.65.49-1.27.58-1.88S208,866.22,208.75,865.36Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.41,866.3A30.82,30.82,0,0,0,209,870c.1.72.3.92.57.76s.46-1.44.31-2.17A10.34,10.34,0,0,1,209.41,866.3Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.81,865.65a13.16,13.16,0,0,0,2,2.09c.61.34,1.59.65,1.76.42s-.34-1.19-.73-1.44-1.51-.55-1.82-.76A3.61,3.61,0,0,0,210.81,865.65Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.51,855.51a5.25,5.25,0,0,0-2.83-.4c-1.2,0-2.39-.39-3-.2s-1.87,0-1.86.76.65,1.2.84,1.71.64,1.7.73,1.83a4.63,4.63,0,0,1-1.54-.53,3.77,3.77,0,0,0-2.35,1.24l-.32.42a1.94,1.94,0,0,0-.23.53,2.35,2.35,0,0,0,1.84-.2c1-.56,1.11-1,2.21-.77l-1.19.8s.11,1,1.17.36c.88-.53,1.78.7,2.38,1.2a1.37,1.37,0,0,1,1.85.49c-.1-.13,1.63-1.13,2.14-1.71a2.25,2.25,0,0,0,.55-1.51,8.14,8.14,0,0,1,1-2.21C214.25,856.63,213.6,856,212.51,855.51Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.94,861.06c-1.06.65-1.17-.36-1.17-.36l1.19-.8c-1.1-.21-1.19.21-2.21.77a2.35,2.35,0,0,1-1.84.2l0,.07c-.08.35.14.64.18,1s.6.4,1.28.58,2.1,1,2.59.93,1.1-.33,1.25-.2a2.58,2.58,0,0,1,1.14-1C207.72,861.76,206.82,860.53,205.94,861.06Z",
    style: {
      fill: "#dedfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.33,863.37a2.44,2.44,0,0,0-.16-.62c-.76-1.27-2.44-.45-3,.46.15.14.09.58.38.76a2.61,2.61,0,0,0,.83.32c.18.06.24.15.22.25h.16C209.38,864.29,209.35,864.51,210.33,863.37Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,909.49a3.66,3.66,0,0,1-4.5-1.62c-.55-.79,1.24-3.23,1.46-6.63s-2.09-3.24-4.49-4.77-6.26-1.64-6.26-1.64l.35-.86c-1,1.14-1,.92-1.56,1.16h-.17a.45.45,0,0,1-.23.26,5.34,5.34,0,0,0-2,1.62c-1.21,1.36-1.89,2.77-1.72,4s0,1.62.35,2.12,3.54,5.94,3.87,6.38,2.44,3.63,2.49,3.89-1,3.67-1,3.67-.07.1.65.2,4.3.24,5-.35,4.65-2,5.65-2.72a21.8,21.8,0,0,1,3.6-2.62,49.52,49.52,0,0,0,5.47-2.68A25.34,25.34,0,0,0,231.28,909.49Z",
    style: {
      fill: "#dedfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.84,894l.24-.19Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: "0.30000000000000004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,902.49a14,14,0,0,0-2.8.77,49.12,49.12,0,0,1-3.91-4.26c-.31-.67-1.8-2.13-2.55-3.31s-.84-1.65-2.11-1.94a38.53,38.53,0,0,1-4.36-1.43,10.86,10.86,0,0,0-3.56-.3c-.55.06-1.57.69-2.76.89a4.44,4.44,0,0,0-1.89.87l-.24.19-.35.86s3.87.12,6.26,1.64,4.72,1.37,4.49,4.77-2,5.84-1.46,6.63a3.66,3.66,0,0,0,4.5,1.62,25.34,25.34,0,0,1,7.05-.59l.11-.08a23.68,23.68,0,0,0,2.93-2.91,10.39,10.39,0,0,0,2-2.53C243.57,902.76,243.41,902.29,242,902.49Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.25,896s-1.72,1.8-1.85,3.29-.58,2.52-.09,2.65.49-1.27.58-1.88S215.51,896.82,216.25,896Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.91,896.9a30.82,30.82,0,0,0-.4,3.69c.1.72.3.92.58.76a3.24,3.24,0,0,0,.3-2.17A11,11,0,0,1,216.91,896.9Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31,896.25a12.86,12.86,0,0,0,2,2.09c.6.34,1.58.65,1.75.42s-.34-1.19-.73-1.44-1.51-.55-1.82-.77A3.73,3.73,0,0,0,218.31,896.25Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,886.11a5.25,5.25,0,0,0-2.83-.4c-1.19,0-2.39-.39-3-.2s-1.87,0-1.86.76.65,1.2.84,1.71.64,1.7.73,1.83a4.63,4.63,0,0,1-1.54-.53,3.77,3.77,0,0,0-2.35,1.24l-.31.42a1.7,1.7,0,0,0-.24.53,2.37,2.37,0,0,0,1.85-.2c1-.56,1.1-1,2.2-.77l-1.19.8s.12,1,1.17.36c.88-.53,1.78.7,2.38,1.2a1.37,1.37,0,0,1,1.85.49c-.1-.13,1.63-1.13,2.14-1.71a2.25,2.25,0,0,0,.55-1.51,8,8,0,0,1,1-2.21C221.76,887.23,221.1,886.63,220,886.11Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.44,891.66c-1.05.65-1.17-.36-1.17-.36l1.19-.8c-1.1-.21-1.19.21-2.2.77a2.37,2.37,0,0,1-1.85.2.14.14,0,0,0,0,.07c-.09.34.13.64.17,1s.6.39,1.28.58,2.1,1,2.6.93,1.09-.33,1.24-.2a2.58,2.58,0,0,1,1.14-.95C215.22,892.36,214.32,891.13,213.44,891.66Z",
    style: {
      fill: "#dedfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.84,894a2.56,2.56,0,0,0-.17-.62c-.76-1.27-2.43-.45-3,.46.15.14.09.58.38.76a2.7,2.7,0,0,0,.83.32c.18.06.24.15.22.25h.17C216.88,894.89,216.85,895.11,217.84,894Z",
    style: {
      fill: "#bcbec0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.21 658.38 242 447.08 227.03 447.08 227.03 658.38 247.21 658.38",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.03 447.08 212.07 447.08 206.86 658.38 227.03 658.38 227.03 447.08",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.1 437.19 208.59 437.19 208.59 447.08 227.03 447.08 227.03 437.19 215.1 437.19",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.47 437.19 238.97 437.19 227.03 437.19 227.03 447.08 245.47 447.08 245.47 437.19",
    style: {
      fill: "#1d2124"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.03 475.21 242.69 475.21 242.36 461.69 227.03 461.69 227.03 475.21",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.03 496.56 243.22 496.56 242.89 483.05 227.03 483.05 227.03 496.56",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.03 581.95 245.32 581.95 243.44 505.46 227.03 505.46 227.03 581.95",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.03,
    y: 461.69,
    height: 13.51,
    style: {
      fill: "#dd642b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.03 461.69 211.71 461.69 211.37 475.21 227.03 475.21 227.03 461.69",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.03,
    y: 483.05,
    height: 13.51,
    style: {
      fill: "#dd642b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.03 483.05 211.18 483.05 210.85 496.56 227.03 496.56 227.03 483.05",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.03,
    y: 505.46,
    height: 76.48,
    style: {
      fill: "#dd642b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.03 505.46 210.63 505.46 208.74 581.95 227.03 581.95 227.03 505.46",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.63,
    cy: 689.41,
    r: 9.55,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 689.41,
    r: 9.55,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.37,
    cy: 689.41,
    r: 9.55,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,939a25,25,0,0,1-48.67,8.33l7.11-12.51s6.32-1.67,6.24-4.83-2-17.74-2-17.74l-1.25-14.53s2.66-2.16,2.66-1.91,7.57,9.23,7.57,9.23l13.14,10.23,9.4,9.65,4.08,14.64Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,885.86c-5,6.87-11.38,12.89-5.09,22.46,6.7,10.19,27.42,27.16,8.59,48.21,3.31-4.21,8.31-22.07-1.69-31.26C133.86,918.56,117.79,902.19,139.34,885.86Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,882.74c-5.28,5.4-10.62,5.09-5.18,14.69s27.71,23.21,6.21,43.41c0,0,11.48-19.4.8-27.33-4.52-3.36-11.58-9.91-12.52-17.3-2.1,5.09-.25,14.87,4,20.86,7.66,10.76,2.63,19.41-7.73,25s-1.43,15,2.55,18.82c-5.77-3.36-16-13.45-10.16-22.09,5.95-8.88,8.72-21.19-1.55-25.74,8.64,2.41,12.53,12.21,11.49,16.41.52-9.4-.26-12.85-5.44-21.65S114.3,886.69,124.56,882.74Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.46,941a23.13,23.13,0,0,1-44.94,7.69l6.56-11.56s5.84-1.53,5.76-4.45S259,916.24,259,916.24l-1.15-13.41s2.46-2,2.46-1.77,7,8.53,7,8.53L279.43,919l8.68,8.91,3.76,13.52Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.65,891.84c-4.64,6.35-10.51,11.91-4.71,20.75,6.19,9.41,25.33,25.08,7.95,44.52,3.05-3.89,7.66-20.39-1.57-28.87C278.59,922,263.75,906.93,283.65,891.84Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,882.85c-4.87,5-9.81,10.81-4.79,19.68S290.8,924,271,942.62c0,0,10.6-17.92.74-25.24-4.17-3.1-10.69-9.15-11.56-16-1.95,4.71-.23,13.74,3.7,19.27,7.07,9.94,2.43,17.92-7.14,23.1s-1.32,13.87,2.36,17.38c-5.33-3.11-14.74-12.42-9.39-20.4,5.5-8.21,8.06-19.57-1.42-23.77,8,2.21,11.56,11.27,10.61,15.15.48-8.69-.24-11.87-5-20S260.52,886.49,270,882.85Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.42,941a23.13,23.13,0,0,0,45,7.69l-6.57-11.56s-5.83-1.53-5.76-4.45,1.85-16.39,1.85-16.39L191,902.83s-2.46-2-2.46-1.77-7,8.53-7,8.53L169.46,919l-8.68,8.91L157,941.46Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.24,891.84c4.64,6.35,10.51,11.91,4.7,20.75-6.18,9.41-25.32,25.08-7.94,44.52-3.05-3.89-7.67-20.39,1.56-28.87C170.3,922,185.14,906.93,165.24,891.84Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.89,882.85c4.87,5,9.81,10.81,4.79,19.68s-16.35,22.17-6.49,14.85c4.18-3.1,10.7-9.15,11.57-16,1.94,4.71.23,13.74-3.7,19.27-7.08,9.94-2.43,17.92,7.13,23.1s1.33,13.87-2.35,17.38c5.33-3.11,14.74-12.42,9.39-20.4-5.5-8.21-8.06-19.57,1.42-23.77-8,2.21-11.56,11.27-10.61,15.15-.48-8.69.24-11.87,5-20S188.37,886.49,178.89,882.85Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92,948.36a15.72,15.72,0,0,0,30.54,5.23L161,945.73s-4-1-3.91-3,1.25-11.14,1.25-11.14l.78-9.12a11.58,11.58,0,0,0-1.67-1.2c0,.16-4.75,5.8-4.75,5.8l-8.24,6.42-5.9,6L136,948.71Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.59,915c3.15,4.31,7.14,8.09,3.2,14.09-4.21,6.4-17.21,17-5.4,30.26-2.08-2.64-5.21-13.85,1.06-19.62C145,935.51,155.11,925.24,141.59,915Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.87,908.87c3.31,3.4,6.66,7.35,3.25,13.38s-17.39,14.57-3.9,27.25c0,0-7.21-12.18-.5-17.16,2.84-2.1,7.26-6.22,7.86-10.85,1.32,3.19.15,9.33-2.52,13.09-4.81,6.75-1.65,12.18,4.85,15.7s.9,9.43-1.6,11.81c3.62-2.11,10.92-10.87,6.38-13.87s-5.75-3.91-6.24-5.85.16-8.07,3.41-13.59S157.31,911.35,150.87,908.87Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.43,948.36A15.72,15.72,0,0,0,251,953.59l-4.46-7.86s-4-1-3.92-3,1.26-11.14,1.26-11.14l.78-9.12a11.58,11.58,0,0,0-1.67-1.2c0,.16-4.75,5.8-4.75,5.8L230,933.47l-5.9,6-2.55,9.19Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09,915c3.16,4.31,7.15,8.09,3.2,14.09-4.2,6.4-17.21,17-5.39,30.26-2.08-2.64-5.22-13.85,1.06-19.62C230.53,935.51,240.62,925.24,227.09,915Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.37,908.87c3.31,3.4,6.67,7.35,3.26,13.38s-11.11,15.07-4.41,10.09c2.84-2.1,7.27-6.22,7.86-10.85,1.32,3.19.16,9.33-2.52,13.09-4.8,6.75-1.65,12.18,4.86,15.7s.9,9.43-1.6,11.81c3.62-2.11,10-8.44,6.37-13.87s-5.47-13.3,1-16.15c-5.42,1.51-7.86,7.66-7.21,10.3-.32-5.91.16-8.07,3.42-13.59S242.81,911.35,236.37,908.87Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.56,945.14c-.36,10.15,8.48,18.94,18.94,18.94a19,19,0,0,0,17.85-12.64L223,942s-4.78-1.26-4.72-3.65,1.51-13.41,1.51-13.41l.94-11s-2-1.63-2-1.44-5.72,7-5.72,7-2.9,1.95-9.93,7.73S191.92,935,191.56,945.14Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.77,897.58c4,4.08,8,8.85,3.91,16.11s-13.37,18.15-5.3,12.16c3.42-2.54,8.75-7.49,9.47-13.08,1.59,3.85.18,11.24-3,15.77-5.79,8.14-2,14.68,5.85,18.91s1.08,11.36-1.93,14.23c4.36-2.54,12.06-10.17,7.69-16.7-4.51-6.72-6.6-16,1.16-19.46-6.53,1.81-9.47,9.23-8.68,12.4-.4-7.11.19-9.71,4.11-16.37S218.53,900.56,210.77,897.58Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.11,947.57A23.14,23.14,0,0,1,405,970.71c-10.08,0-18.63-13.07-21.81-22.07l6.56-4.94s5.84-1.53,5.76-4.45-1.84-16.39-1.84-16.39l-1.15-13.41s2.46-2,2.46-1.77,7,8.53,7,8.53l12.14,9.45,8.68,8.9,3.76,13.52Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.64,889.47c-4.86,5-9.8,10.81-4.78,19.68s25.59,21.43,5.74,40.09c0,0,10.6-17.92.74-25.24-4.18-3.1-10.69-9.15-11.57-16-1.94,4.7-.22,13.73,3.71,19.26,7.07,9.94,2.43,17.93-7.14,23.1s-1.32,13.87,2.36,17.38c-5.33-3.11-14.74-19-9.39-27,5.5-8.21,8.05-19.57-1.43-23.77,8,2.21,11.57,17.89,10.62,21.77.47-8.68-.24-11.87-5-20S395.17,893.12,404.64,889.47Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.07,941A23.13,23.13,0,0,0,335,948.64l-6.56-11.56s-5.83-1.53-5.76-4.45,1.85-16.39,1.85-16.39l1.15-13.41s-2.46-2-2.46-1.77-7,8.53-7,8.53L304.11,919l-8.68,8.91-3.77,13.52Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,891.84c4.65,6.35,10.52,11.91,4.71,20.75-6.18,9.41-25.32,25.08-7.94,44.52-3.06-3.89-7.67-20.39,1.56-28.87C305,922,319.79,906.93,299.88,891.84Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.54,882.85c4.87,5,9.81,10.81,4.78,19.68s-25.59,21.43-5.74,40.09c0,0-10.6-17.92-.74-25.24,4.18-3.1,10.7-9.15,11.57-16,1.94,4.71.23,13.74-3.71,19.27-7.07,9.94-2.42,17.92,7.14,23.1s1.33,13.87-2.35,17.38c5.33-3.11,14.73-12.42,9.38-20.4-5.5-8.21-8.05-19.57,1.43-23.77-8,2.21-11.57,11.27-10.61,15.15-.48-8.69.24-11.87,5-20S323,886.49,313.54,882.85Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.57,948.36a15.72,15.72,0,0,0,30.54,5.23l-4.46-7.86s-4-1-3.91-3S293,931.57,293,931.57l.78-9.12a11.58,11.58,0,0,0-1.67-1.2c0,.16-4.75,5.8-4.75,5.8l-8.24,6.42-5.9,6-2.56,9.19Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.24,915c3.15,4.31,7.14,8.09,3.2,14.09-4.21,6.4-17.21,17-5.4,30.26-2.08-2.64-5.21-13.85,1.06-19.62C279.68,935.51,289.76,925.24,276.24,915Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.52,908.87c3.31,3.4,6.66,7.35,3.25,13.38s-17.39,14.57-3.9,27.25c0,0-7.21-12.18-.51-17.16,2.84-2.1,7.27-6.22,7.87-10.85,1.32,3.19.15,9.33-2.52,13.09-4.81,6.75-1.65,12.18,4.85,15.7s.9,9.43-1.6,11.81c3.62-2.11,10-8.44,6.38-13.87s-5.48-13.3,1-16.15c-5.43,1.51-7.87,7.66-7.21,10.3-.33-5.91.16-8.07,3.41-13.59S292,911.35,285.52,908.87Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.07,948.36a15.72,15.72,0,0,0,15.73,15.72c6.85,0,12.65,2.24,14.82-3.87l-4.46-14.48s-4-1-3.92-3,1.26-11.14,1.26-11.14l.78-9.12a11.58,11.58,0,0,0-1.67-1.2c0,.16-4.75,5.8-4.75,5.8l-8.25,6.42-5.9,6-2.56,9.19Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.74,915c3.16,4.31,7.15,8.09,3.2,14.09-4.2,6.4-17.21,17-5.39,30.26-2.08-2.64-5.22-13.85,1.06-19.62C365.18,935.51,375.27,925.24,361.74,915Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,908.87c3.31,3.4,6.67,7.35,3.25,13.38s-17.39,14.57-3.9,27.25c0,0-7.2-12.18-.5-17.16,2.84-2.1,7.27-6.22,7.86-10.85,1.32,3.19.15,9.33-2.52,13.09-4.8,6.75-1.65,12.18,4.85,15.7s.9,9.43-1.6,11.81c3.63-2.11,10-8.44,6.38-13.87s-5.47-6.68,1-9.53c-5.42,1.51-7.86,1-7.21,3.68-.32-5.91.16-8.07,3.41-13.59S377.46,911.35,371,908.87Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.2,945.14a18.94,18.94,0,0,0,36.8,6.3L357.63,942s-4.78-1.26-4.72-3.65,1.51-13.41,1.51-13.41l.94-11s-2-1.63-2-1.44-5.72,7-5.72,7l-9.94,7.73-7.1,7.3-3.08,11.06Z",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.24,904.94c3.8,5.2,8.61,9.75,3.85,17-5.06,7.71-20.73,20.54-6.5,36.45-2.5-3.18-6.28-16.69,1.28-23.63C338.38,929.67,350.53,917.29,334.24,904.94Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.42,897.58c4,4.08,8,8.85,3.91,16.11s-20.95,17.55-4.7,32.82c0,0-8.67-14.67-.6-20.66,3.42-2.54,8.75-7.49,9.47-13.08,1.59,3.85.18,11.24-3,15.77-5.79,8.14-2,14.68,5.85,18.91s1.08,11.36-1.93,14.23c4.36-2.54,12.06-10.17,7.68-16.7-4.5-6.72-6.59-16,1.17-19.46-6.53,1.81-9.47,9.23-8.69,12.4-.39-7.11.2-9.71,4.12-16.37S353.17,900.56,345.42,897.58Z",
    style: {
      fill: "#e16d00"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "111.09 738.25 98.06 788.71 107.22 795.01 120.25 744.54 111.09 738.25",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.43 732.98 75.69 773.34 92.39 784.82 105.43 734.36 103.43 732.98",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.92 748.43 112.88 798.9 122.04 805.2 135.08 754.73 125.92 748.43",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.56 768.81 142.53 819.27 151.69 825.57 164.73 775.1 155.56 768.81",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.74 758.62 127.7 809.09 136.87 815.38 149.9 764.92 140.74 758.62",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.34 837.7 182.38 787.24 170.39 778.99 157.35 829.46 169.34 837.7",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.43 734.36 92.39 784.82 98.06 788.71 111.09 738.25 105.43 734.36",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.25 744.54 107.22 795.01 112.88 798.9 125.92 748.43 120.25 744.54",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.08 754.73 122.04 805.2 127.7 809.09 140.74 758.62 135.08 754.73",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.9 764.92 136.87 815.38 142.53 819.27 155.56 768.81 149.9 764.92",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.39 778.99 164.73 775.1 151.69 825.57 157.35 829.46 170.39 778.99",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.44 837.7 162.44 837.7 53.45 837.7 53.45 848.39 159.33 848.39 162.44 848.39 165.85 848.39 169.34 837.7 162.44 837.7",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.21 794.9 18.09 799.95 29.76 799.95 35.16 799.95 45.77 799.95 48.37 799.95 48.37 802.99 48.37 821.67 48.37 824.71 45.77 824.71 35.16 824.71 29.76 824.71 14 824.71 14 824.71 9.91 828.17 9.91 845.27 14 845.27 14 845.27 14 850.87 31.91 850.87 53.45 850.86 53.45 794.9 20.21 794.9",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.76 802.99 18.09 802.99 14 821.67 29.76 821.67 29.76 802.99",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.16,824.71H48.37V800H18.09v3H29.76v18.68H14v3H35.16Zm0-21.72H45.77v18.68H35.16Z",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.76,
    y: 802.99,
    width: 16.01,
    height: 18.68,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.41,
    y: 845.27,
    width: 19.32,
    height: 5.6,
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.38 787.23 215.02 827.87 222.42 825.35 189.78 784.72 182.38 787.23",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.68 773.88 237.44 820.25 231.33 822.33 215.57 775.95 196.28 782.51 228.93 823.14 237.45 820.25 240.66 809.21 227.93 771.75 221.68 773.88",
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.78 784.72 222.42 825.35 228.93 823.14 196.28 782.51 189.78 784.72",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 773.61,
    width: 6.45,
    height: 48.98,
    transform: "translate(-244.69 115.28) rotate(-18.76)",
    style: {
      fill: "#e16d00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.46,
    cy: 847.71,
    r: 12.68,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.46,
    cy: 847.71,
    r: 5.59,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.28,
    cy: 847.71,
    r: 12.68,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.28,
    cy: 847.71,
    r: 5.59,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.59,
    cy: 847.71,
    r: 12.68,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.59,
    cy: 847.71,
    r: 5.59,
    style: {
      fill: "#d4d4d4"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDioxin01);
export default __webpack_public_path__ + "static/media/dioxin_01.1ca0cf22ddb85e079801abfab0c442f0.svg";
export { ForwardRef as ReactComponent };